var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('new-modal-wrapper', {
    ref: "NewPlacementWarningModal",
    attrs: {
      "widthModal": '80%',
      "maxWidthModal": 500,
      "modal-name": "NewPlacementWarningModal",
      "show-close-icon": true,
      "click-to-close": true,
      "cta-secondary-button": _vm.isApparel ? null : 'placementWarningGoBack',
      "cta-primary-button": _vm.isApparel ? 'apparelPlacementWarningGoBack' : 'placementWarningContinue',
      "show-cta-secondary-button": !_vm.isApparel,
      "overrideFocusValue": true
    },
    on: {
      "cta-action": _vm.onContinue,
      "cta-secondary-action": _vm.closeModal
    }
  }, [_vm.isApparel ? _c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations.apparelPlacementWarningHeader))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.apparelPlacementWarningDesc) + "\n    ")])]) : _c('div', [_c('div', {
    staticClass: "new-modal-error-icon"
  }, [_vm._v("!")]), _c('h2', {
    staticClass: "new-modal-title"
  }, [_vm._v(_vm._s(_vm.translations.placementWarningHeader))]), _c('p', {
    staticClass: "new-modal-description"
  }, [_vm._v("\n      " + _vm._s(_vm.translations.placementWarningDesc) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }